import { Box, Button, GridItem, HStack, Icon, IconButton, Text, VStack } from '@chakra-ui/react';
import { LuArrowLeft, LuRotateCcw, LuX } from 'react-icons/lu';

import LogItem, { LogItemProps } from '../LogItem/LogItem';

interface ExecutionLogPanelProps {
  logs: LogItemProps[];
  onCloseClick: () => void;
  onRetryClick: () => void;
  isLoadingRunAgent?: boolean;
}

const ExecutionLogPanel = ({ logs, onCloseClick, onRetryClick, isLoadingRunAgent }: ExecutionLogPanelProps) => {

  return (
    <GridItem position="relative">
      <Box
        bg="white"
        p={{ base: 6, md: 6 }}
        position={{ lg: 'fixed' }}
        top={{ lg: 'var(--app-header-h)' }}
        right={{ lg: 0 }}
        h={{ lg: 'calc(100dvh - var(--app-header-h))' }}
        display="flex"
        flexDirection="column"
        boxShadow="6px 6px 54px 0 rgba(0, 0, 0, 0.05)"
        overflow="hidden"
        maxH={{ lg: 'calc(100dvh - var(--app-header-h))' }}
        width={{ lg: 'calc((100% - 100px) * 0.375)' }}
        zIndex={10}
      >
        <HStack justify="space-between" mb={8} flexShrink={0}>
          <HStack gap={3}>
            <IconButton
              variant="ghost"
              size="sm"
              onClick={onCloseClick}
              aria-label="Back"
              _hover={{ backgroundColor: 'gray.100' }}
            >
              <Icon as={LuArrowLeft} boxSize={5} color="gray.solid" />
            </IconButton>
            <Text fontSize={24} fontWeight={500}>
              Test Agent
            </Text>
          </HStack>
          <IconButton
            variant="ghost"
            size="sm"
            onClick={onCloseClick}
            aria-label="Close"
            _hover={{ backgroundColor: 'gray.100' }}
          >
            <Icon as={LuX} boxSize={5} color="gray.600" />
          </IconButton>
        </HStack>
        <VStack align="stretch" gap={50} overflowY="auto" flex="1" minH={0}>
          {logs.map((item, idx) => (
            <LogItem key={idx} item={item} />
          ))}
        </VStack>
        <Box position="sticky" bottom={0} bg="white" display="flex" justifyContent="flex-end" pt={4}>
          <Button
            backgroundColor="purple.fg"
            color="white"
            px={4}
            py={0.5}
            fontSize={14}
            fontWeight={600}
            borderRadius={4}
            _hover={{
              backgroundColor: 'purple.600',
            }}
            onClick={onRetryClick}
            loading={isLoadingRunAgent}
            loadingText="Retrying..."
          >
            <LuRotateCcw />
            Retry
          </Button>
        </Box>
      </Box>
    </GridItem>
  );
};

export default ExecutionLogPanel;
